import { Collapse as AntCollapse } from 'antd';
import css from './collapse.module.scss';

type CollapseType = {
    key: string;
    text: string;
    value: string;
    disabled?: boolean | undefined;
};

export default function Collapse({ data, pageType = '', ...rest }: any) {
    const { Panel } = AntCollapse;
    const classList = [css.efCollapse];
    const props = { ...rest };
    if (rest.className) {
        classList.push(rest.className);
        props.className = classList;
    }
    return (
        <AntCollapse {...props}>
            {pageType == 'accessories' &&
                data &&
                data.map((item: CollapseType) => (
                    <Panel key={item.key} header={item.text}>
                        {item.list && item.list.map((list: any, i: any) => <p key={list}>{list}</p>)}
                    </Panel>
                ))}
            {pageType == '' &&
                data &&
                data.map((item: CollapseType) => (
                    <Panel key={item.key} header={item.text} className="site-collapse-custom-panel">
                        <div>{item.value}</div>
                    </Panel>
                ))}
        </AntCollapse>
    );
}
